import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Typography, Button, Card, Col, Row, Select, Spin, Empty } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import * as dropdownActions from "../../../../actionCreators/DropDown";
import * as propertyActions from "../../../../actionCreators/Property";
import * as taxActions from "../../../../actionCreators/TaxCollection";
import * as ZonesAction from "../../../../actionCreators/Zones";
import InputLabel from "../../../../Components/FloatingSelectLabel/FloatingSelectLabel";
import "./reports.css";
import BarChart from "../graph-plots/bar";
import { customColorFunction } from "../../../../utils/reportsUtils";
import { getFiscalYear } from "../../../../utils/dateTime";
const { Option } = Select;

const TaxInspectorReport = (props) => {
  const isAdmin = (user) =>
    user?.currentUser?.data?.user_roles[0]?.role?.role === "Admin" || user?.currentUser?.data?.user_roles[0]?.role?.role === "District Admin";
  const getColConfig = (isAdmin) =>
    isAdmin
      ? { xs: 24, sm: 24, md: 24, lg: 6, xl: 6 }
      : { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 };

  const colConfig = getColConfig(isAdmin(props?.user)); //incorporate props changes
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [districtSelectActive, setDistrictSelectActive] = useState(false);
  const [selectedZone, setSelectedZone] = useState(null);
  const [zoneSelectActive, setZoneSelectActive] = useState(false);
  const [selectedCircle, setSelectedCircle] = useState(null);
  const [circleSelectActive, setCircleSelectActive] = useState(false);
  const [selectedTi, setSelectedTi] = useState(null);
  const [tiSelectActive, setTiSelectActive] = useState(false);
  const [columnData, setColumnData] = useState([]);
  const history = useHistory();

  useEffect(() => {
    if (isAdmin(props?.user)) {
      props.getDistricts();
    } else {
      props.getEtoZones();
    }
  }, []);

  useEffect(() => {
    const role = props?.user?.currentUser?.data?.user_roles[0]?.role?.role;
    if ((role === "Admin" || role === "District Admin") && selectedDistrict) {
      setSelectedCircle(null);
      setSelectedZone(null);
      setSelectedTi(null);
      props?.getZonesOfDistrict({ districtId: selectedDistrict });
    }
  }, [selectedDistrict]);

  useEffect(() => {
    if (selectedZone) {
      props.getCirclesByZone({ zone_id: selectedZone });
      setSelectedCircle(null);
      setSelectedTi(null);
    }
  }, [selectedZone]);

  useEffect(() => {
    if (selectedCircle) {
      props.getTisByCircle({ circleId: selectedCircle });
    }
  }, [selectedCircle]);

  useEffect(() => {
    if (selectedTi) {
      props.getTiDetails({ tiId: selectedTi });
      props.getTiPropertStats({ tiId: selectedTi, circleId: selectedCircle });
      props.getYearlyPaidTaxTi({ tiId: selectedTi, circleId: selectedCircle });
      props.getTITotalPendingTax({
        tiId: selectedTi,
        circleId: selectedCircle,
      });
    }
  }, [selectedTi]);
  useEffect(() => {
    setSelectedTi(null);
  }, [props.tisInCircle]);
  useEffect(() => {
    const currentYear = getFiscalYear();
    const newData = [];
    const intermediate = {};
    props.yearlyPaidTaxTi.data.forEach((element) => {
      intermediate[element.taxyear] = {
        tax: parseInt(element.paidtax),
      };
    });
    for (let i = currentYear - 2; i <= currentYear; i++) {
      if (intermediate[i]) {
        newData.push({
          tax: intermediate[i].tax,
          name: "COLLECTED TAX",
          year: i,
        });
      } else {
        newData.push({
          tax: 0,
          name: "COLLECTED TAX",
          year: i,
        });
      }
    }
    newData[newData.length - 1].year = `${
      newData[newData.length - 1].year
    }\n(current)`;
    setColumnData(newData);
  }, [props.yearlyPaidTaxTi]);

  const onZoneDropDownValueChange = (value) => {
    setSelectedZone(value);
  };

  const onCircleDropDownValueChange = (value) => {
    setSelectedCircle(value);
  };

  const onTiDropDownValueChange = (value) => {
    setSelectedTi(value);
  };

  return (
    <div>
      <Spin
        spinning={
          props?.districts?.loading ||
          props.etoZones.loading ||
          props.circlesInZone.loading ||
          props.tisInCircle.loading ||
          props.tiDetails.loading ||
          props.tiPropertyStats.loading ||
          props.getYearlyPaidTaxTi.loading ||
          props.totalPendingTaxTi.loading
        }
      >
        <div className="header">
          <Typography className="heading">TI performance</Typography>
          <div>
            <Button
              className="export-report-button"
              type={selectedTi ? "primary" : "ghost"}
              icon={<FilePdfOutlined />}
              disabled={selectedTi ? false : true}
              onClick={() =>
                history.push(
                  `/reports/taxInspector-pdf/${selectedTi}/circle/${selectedCircle}`
                )
              }
            >
              EXPORT REPORT
            </Button>
          </div>
        </div>
        <div>
          <Row gutter={[16, 16]}>
            <Card
              title="Select Tax Inspector"
              bordered={false}
              headStyle={{
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "20px",
                letterSpacing: "0.15px",
                border: "none",
              }}
              style={{
                width: "98.5%",
                margin: "auto",
              }}
            >
              <Row gutter={[16, 16]}>
                {isAdmin(props?.user) && (
                  <Col {...colConfig}>
                    <div
                      onFocus={() => {
                        setDistrictSelectActive(true);
                      }}
                      onBlur={() => {
                        setDistrictSelectActive(false);
                      }}
                      className="dropdowns"
                    >
                      <InputLabel
                        value={selectedDistrict}
                        labelText="District"
                        active={districtSelectActive}
                      >
                        <Select onChange={setSelectedDistrict} size="large">
                          {props.districts?.data?.map((district) => (
                            <Option value={district.id}>{district.name}</Option>
                          ))}
                        </Select>
                      </InputLabel>
                    </div>
                  </Col>
                )}
                <Col {...colConfig}>
                  <div
                    onFocus={() => {
                      setZoneSelectActive(true);
                    }}
                    onBlur={() => {
                      setZoneSelectActive(false);
                    }}
                    className="dropdowns"
                  >
                    <InputLabel
                      value={selectedZone}
                      labelText="Zone"
                      active={zoneSelectActive}
                    >
                      <Select
                        onChange={onZoneDropDownValueChange}
                        value={selectedZone}
                        size="large"
                        disabled={isAdmin(props?.user) && !selectedDistrict}
                      >
                        {isAdmin(props?.user)
                          ? props.zonesOfDistrict?.data?.map((zone) => (
                              <Option value={zone.id}>{zone.name}</Option>
                            ))
                          : props.etoZones?.data?.map((zone) => (
                              <Option value={zone.id}>{zone.zone}</Option>
                            ))}
                      </Select>
                    </InputLabel>
                  </div>
                </Col>
                <Col {...colConfig}>
                  <div
                    onFocus={() => {
                      setCircleSelectActive(true);
                    }}
                    onBlur={() => {
                      setCircleSelectActive(false);
                    }}
                    className="dropdowns"
                  >
                    <InputLabel
                      value={selectedCircle}
                      labelText="Circle"
                      active={circleSelectActive}
                    >
                      <Select
                        onChange={onCircleDropDownValueChange}
                        value={selectedCircle}
                        size="large"
                        disabled={!selectedZone}
                      >
                        {props.circlesInZone.data?.map((circle) => (
                          <Option value={circle.id}>{circle.name}</Option>
                        ))}
                      </Select>
                    </InputLabel>
                  </div>
                </Col>
                <Col {...colConfig}>
                  <div
                    onFocus={() => {
                      setTiSelectActive(true);
                    }}
                    onBlur={() => {
                      setTiSelectActive(false);
                    }}
                    className="dropdowns"
                  >
                    <InputLabel
                      value={selectedTi}
                      labelText="Tax Inspector"
                      active={tiSelectActive}
                    >
                      <Select
                        onChange={onTiDropDownValueChange}
                        value={selectedTi}
                        size="large"
                        disabled={!selectedCircle}
                      >
                        {props?.tisInCircle?.data?.map((ti, index) => (
                          <Option value={ti.tiid} key={ti.tiId + index}>
                            {ti.tiname}
                          </Option>
                        ))}
                      </Select>
                    </InputLabel>
                  </div>
                </Col>
              </Row>
            </Card>
          </Row>
          <br />
          {selectedTi && (
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Card
                  title="TI Details"
                  headStyle={{
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "20px",
                    letterSpacing: "0.15px",
                    border: "none",
                  }}
                >
                  <Typography className="ti-details-header">Name</Typography>
                  <Typography className="ti-details-data">
                    {props.tiDetails.data
                      ? props.tiDetails.data.full_name
                      : "-"}
                  </Typography>
                  <br />
                  <Typography className="ti-details-header">Email</Typography>
                  <Typography className="ti-details-data">
                    {props.tiDetails.data ? props.tiDetails.data.email : "-"}
                  </Typography>
                  <br />
                  <Typography className="ti-details-header">
                    District
                  </Typography>
                  <Typography className="ti-details-data">
                    {props.tiDetails.data
                      ? props.tiDetails.data.user_roles[0].circles[0].zone
                          .district.name
                      : "-"}
                  </Typography>
                  <br />
                  <Typography className="ti-details-header">Phone</Typography>
                  <Typography className="ti-details-data">
                    {props.tiDetails.data ? props.tiDetails.data.phone : "-"}
                  </Typography>
                  <br />
                  <Typography className="ti-details-header">Circles</Typography>
                  <Typography className="ti-details-data">
                    {props.tiDetails.data
                      ? props.tiDetails?.data?.user_roles[0]?.circles.reduce(
                          (reduced, item, index) => {
                            if (index === 0) {
                              return item?.name;
                            }
                            return (reduced += " , " + item?.name);
                          },
                          ""
                        )
                      : "-"}
                  </Typography>
                </Card>
              </Col>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Card>
                  <Typography className="report-stats-header">
                    PROPERTIES REGISTERED
                  </Typography>
                  <Row>
                    <Col span={12}>
                      <Typography className="report-stats-data">
                        {props.tiPropertyStats.data
                          ? props.tiPropertyStats.data.totalRegistered
                          : "-"}
                        <span
                          style={{
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "13px",
                            display: "inline",
                            color: "gray",
                          }}
                        >
                          {" "}
                          total
                        </span>
                      </Typography>
                    </Col>
                    <Col span={12}>
                      <Typography className="report-stats-data">
                        {props.tiPropertyStats.data
                          ? props?.tiPropertyStats?.data?.currentFiscalYear
                          : "-"}
                        <span
                          style={{
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "13px",
                            display: "inline",
                            color: "gray",
                          }}
                        >
                          {" "}
                          current fiscal year
                        </span>
                      </Typography>
                    </Col>
                  </Row>
                </Card>
                <br />
                <Card>
                  <Typography className="report-stats-header">
                    TOTAL NEW PROPERTIES ASSESSED
                  </Typography>
                  <Typography className="report-stats-data">
                    {props.tiPropertyStats.data
                      ? props.tiPropertyStats.data.submittedToEto
                      : "-"}
                    <span
                      style={{
                        fontStyle: "normal",
                        fontWeight: 400,
                        fontSize: "13px",
                        display: "inline",
                        color: "gray",
                      }}
                    >
                      {" "}
                      submitted to ETO
                    </span>
                  </Typography>
                </Card>
                <br />
                <Card>
                  <Typography className="report-stats-header">
                    TOTAL PROPERTIES AWAITING INSPECTION
                  </Typography>
                  <Typography className="report-stats-data">
                    {props.tiPropertyStats.data
                      ? props.tiPropertyStats.data.awaitingInspection
                      : "-"}
                  </Typography>
                </Card>
                <br />
                <Card>
                  <Typography className="report-stats-header">
                    PENDING TAX CURRENT FISCAL YEAR
                  </Typography>
                  <Typography className="report-stats-data">
                    PKR{" "}
                    {props.totalPendingTaxTi.data
                      ? parseInt(
                          props?.totalPendingTaxTi?.data?.pendingTax
                            ? props?.totalPendingTaxTi?.data?.pendingTax
                            : 0
                        ).toLocaleString()
                      : "-"}
                  </Typography>
                </Card>
              </Col>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Card
                  title="Collected Tax"
                  headStyle={{
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "20px",
                    letterSpacing: "0.15px",
                    border: "none",
                  }}
                  className="full-height-card"
                  style={{ padding: "5px" }}
                >
                  {props?.yearlyPaidTaxTi?.data?.length ? (
                    <BarChart
                      data={columnData}
                      xField="year"
                      yField="tax"
                      xLabel="Fiscal Year"
                      yLabel="Tax (PKR)"
                      customColorFtn={customColorFunction({
                        name: "COLLECTED TAX",
                      })}
                      loading={props?.yearlyPaidTaxTi?.loading}
                      isNoData={!props?.yearlyPaidTaxTi?.data?.length}
                    />
                  ) : (
                    <Empty />
                  )}
                </Card>
              </Col>
            </Row>
          )}
        </div>
      </Spin>
    </div>
  );
};

const mapStateToProps = ({
  user: user,
  dropDown: { etoZones, circlesInZone, tisInCircle, districts },
  property: { tiDetails, tiPropertyStats },
  taxCollection: { yearlyPaidTaxTi, totalPendingTaxTi },
  zones: { zonesOfDistrict },
}) => ({
  user,
  etoZones,
  circlesInZone,
  tisInCircle,
  tiDetails,
  tiPropertyStats,
  yearlyPaidTaxTi,
  totalPendingTaxTi,
  districts,
  zonesOfDistrict,
});

const mapDispatchToProps = (dispatch) => ({
  getEtoZones: bindActionCreators(dropdownActions.getEtoZones, dispatch),
  getCirclesByZone: bindActionCreators(
    dropdownActions.getCirclesByZone,
    dispatch
  ),
  getTisByCircle: bindActionCreators(dropdownActions.getTisByCircle, dispatch),
  getTiDetails: bindActionCreators(propertyActions.getTiDetails, dispatch),
  getTiPropertStats: bindActionCreators(
    propertyActions.getTiPropertStats,
    dispatch
  ),
  getYearlyPaidTaxTi: bindActionCreators(
    taxActions.getYearlyPaidTaxTi,
    dispatch
  ),
  getTITotalPendingTax: bindActionCreators(
    taxActions.getTITotalPendingTax,
    dispatch
  ),
  getDistricts: bindActionCreators(dropdownActions.getDistricts, dispatch),
  getZonesOfDistrict: bindActionCreators(
    ZonesAction.getZonesOfDistrict,
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaxInspectorReport);
